import * as types from './mutation-types'

export default {
  [types.ADD_FEES](state, data) {
    state.fees = data.data
  },
  [types.ADD_FEE](state, data) {
    state.fees.push(data)
  },
}
